import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './hooks/useAuth'
import { ProtectedRoute } from './components/auth/ProtectedRoute'
import { AppLayout } from './components/layout/AppLayout'

// Pages
import { Login }          from './pages/Login'
import { ForgotPassword } from './pages/ForgotPassword'
import { ResetPassword }  from './pages/ResetPassword'
import { Onboarding }     from './pages/Onboarding'
import { UniverseMap }    from './pages/UniverseMap'
import { Certifications }  from './pages/Certifications'
import { Packages }        from './pages/Packages'
import { LessonPage }     from './pages/LessonPage'
import { CertificatePage } from './pages/Certificate'
import { Settings }       from './pages/Settings'
import { TreeSelection }  from './pages/TreeSelection'

import './styles/global.css'

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public auth routes — all handled by Login */}
          <Route path="/login"           element={<Login />} />
          <Route path="/signup"          element={<Navigate to="/login?tab=register" replace />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password"  element={<ResetPassword />} />

          {/* Root — send to login, ProtectedRoute handles auth'd redirect */}
          <Route path="/" element={<Navigate to="/login" replace />} />

          {/* Onboarding — auth required, outside AppLayout */}
          <Route path="/onboarding" element={
            <ProtectedRoute><Onboarding /></ProtectedRoute>
          } />

          {/* Tree selection */}
          <Route path="/choose-your-path" element={
            <ProtectedRoute><TreeSelection /></ProtectedRoute>
          } />

          {/* Protected app routes — inside AppLayout */}
          <Route path="/*" element={
            <ProtectedRoute>
              <AppLayout>
                <Routes>
                  <Route path="/dashboard"      element={<UniverseMap />} />
                  <Route path="/certifications" element={<Certifications />} />
                  <Route path="/packages"       element={<Packages />} />
                  <Route path="/learn"       element={<Navigate to="/dashboard" replace />} />
                  <Route path="/learn/:slug" element={<LessonPage />} />
                  <Route path="/certificate" element={<CertificatePage />} />
                  <Route path="/settings"    element={<Settings />} />
                  <Route path="/"            element={<Navigate to="/dashboard" replace />} />
                  <Route path="*"            element={<Navigate to="/dashboard" replace />} />
                </Routes>
              </AppLayout>
            </ProtectedRoute>
          } />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App
